var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "sh": "태성 이혼가사변호사",
            "tabActive": "변호사 소개",
            "bg": "/images/sub/visual/sv-about.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "lawyer-view__head",
    attrs: {
      "tit": this.lawyer.representative ? `${this.lawyer.title} 변호사 소개` : '변호사 소개',
      "titAdd": "법무법인 태성",
      "titClass": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function () {
        return [_c('v-img', {
          staticClass: "text-bg w-100",
          attrs: {
            "src": "/images/sub/taesung/lawyer/lawyer-bg.svg",
            "max-width": "1840",
            "aspect-ratio": 1840 / 266
          }
        })];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "lawyer-view__body page-section--sm secondary"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "7"
    }
  }, [this.lawyer.title === '최유나' ? [_c('lawyer-choi-head')] : this.lawyer.title === '문종하' ? [_c('lawyer-moon-head')] : this.lawyer.title === '정지은' ? [_c('tit', {
    staticClass: "tit--lg white--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("새로운 시작")]), _vm._v("을 위한 "), _c('br'), _vm._v(" 첫걸음을 함께 내딛겠습니다. ")]), _c('span', {
    staticClass: "line my-12px my-md-24px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('div', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('tit', {
    staticClass: "tit--sm primary--text line-height-1 font-secondary",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(this.lawyer.titleEn))])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('tit', {
    staticClass: "tit--xxl white--text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v(_vm._s(this.lawyer.title))])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt', {
    staticClass: "txt--xl white--text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [this.lawyer.ceo ? _c('span', [_vm._v("대표 ")]) : _vm._e(), _vm._v("변호사")])], 1)], 1)], 1)] : [_c('div', {
    staticClass: "lawyer-view__body-contents"
  }, [_c('tit', {
    staticClass: "lawyer-view__body-tit tit--lg white--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 법무법인 태성의 변호사는 "), _c('br'), _vm._v(" 언제나 여러분 곁에 함께 하겠습니다. ")]), _c('div', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('tit', {
    staticClass: "tit--sm primary--text line-height-1 font-secondary",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(this.lawyer.titleEn))])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('tit', {
    staticClass: "tit--xxl white--text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v(_vm._s(this.lawyer.title))])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt', {
    staticClass: "txt--xl white--text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [this.lawyer.ceo ? _c('span', [_vm._v("대표 ")]) : _vm._e(), _vm._v("변호사")])], 1)], 1)], 1)], 1)]], 2), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "offset": "4",
      "offset-sm": "7",
      "offset-md": "0"
    }
  }, [_c('div', {
    staticClass: "lawyer-img-wrap"
  }, [_c('v-img', {
    staticClass: "lawyer-img w-100",
    attrs: {
      "data-aos": "fade-left",
      "src": '/images/lawyer/view/' + this.lawyer.title + '.png',
      "max-width": "586",
      "aspect-ratio": 586 / 900
    }
  })], 1)])], 1)], 1), this.lawyer.info ? _c('page-section', {
    staticClass: "lawyer-view__foot page-section--last page-section--sm"
  }, _vm._l(this.lawyer.info, function (info, index) {
    return _c('info-row', {
      key: index,
      attrs: {
        "title": info.title,
        "topLine": index == 0
      }
    }, [info.text ? [_vm._v(" " + _vm._s(info.text) + " ")] : _vm._e(), _vm._l(info.infoDetail, function (detail, index) {
      return _c('info-detail', {
        key: index,
        class: index !== 0 ? 'mt-10px mt-md-16px' : ''
      }, [typeof detail === 'string' ? _c('span', [_vm._v(_vm._s(detail))]) : detail.bold ? _c('strong', [_vm._v(_vm._s(detail.txt))]) : _vm._e()]);
    })], 2);
  }), 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }